"use-strict";
class StickyAddCart extends Popup {
  constructor() {
    super(), this.init();
  }
  init() {
    this.getHeightAddToCart();
    const btn_minimal = this.querySelector("minimal-button");
    btn_minimal &&
      btn_minimal.addEventListener("click", this.toggle.bind(this), !1);
  }
  getHeightAddToCart() {
    const _this = this;
    if (
      ((this.main = document.querySelector(".main-product-section")),
      !this.main)
    )
      return;
    const primaryBtn = this.main.querySelector(".product-sticky-show"),
      footer = document.querySelector(".product-sticky-hide");
    if (primaryBtn) {
      var isVisible = !0;
      window.addEventListener("scroll", function () {
        var buttonRect = primaryBtn.getBoundingClientRect(),
          viewportHeight = window.innerHeight;
        if (footer) {
          var footerRect = footer.getBoundingClientRect();
          footerRect.top < window.innerHeight - 100
            ? (_this.classList.remove("show-sticky-cart"), (isVisible = !0))
            : !isVisible &&
              buttonRect.top < viewportHeight &&
              buttonRect.bottom > 0
            ? ((isVisible = !0), _this.classList.remove("show-sticky-cart"))
            : isVisible &&
              buttonRect.bottom <= 0 &&
              ((isVisible = !1), _this.classList.add("show-sticky-cart"));
        } else !isVisible && buttonRect.top < viewportHeight && buttonRect.bottom > 0 ? ((isVisible = !0), _this.classList.remove("show-sticky-cart")) : isVisible && buttonRect.bottom <= 0 && ((isVisible = !1), _this.classList.add("show-sticky-cart"));
      });
    }
  }
  toggle(e) {
    const target = e.currentTarget;
    if ((target.classList.toggle("opened"), !target)) return;
    const parent = target.closest("sticky-buy");
    if (!parent) return;
    const content = parent.querySelector(".expand-content");
    slideAnime({
      target: content,
      animeType: "slideToggle",
    });
  }
}
customElements.define("sticky-buy", StickyAddCart);
class GalleryGrid extends SlideSection {
  constructor() {
    super(), this.init();
  }
  init() {
    this.onResize(),
      setTimeout(() => {
        this.pauseMediaGrid(), this.playMediaGrid();
      }, 300);
  }
  onResize() {
    const _this = this;
    let windowWidth = window.innerWidth,
      isMobile = windowWidth <= 767;
    window.addEventListener("resize", function () {
      const newWindowWidth = window.innerWidth,
        newIsMobile = newWindowWidth <= 767;
      newIsMobile !== isMobile &&
        ((windowWidth = newWindowWidth),
        (isMobile = newIsMobile),
        _this.actionResize(isMobile),
        _this.pauseMediaGrid(),
        _this.playMediaGrid());
    }),
      _this.actionResize(isMobile);
  }
  actionResizeLazyLoad(container, content) {
    const sl = document.createElement("div");
    (container.innerHTML = ""),
      content &&
        container &&
        (sl.classList.add("slide-container"),
        container.classList.remove(
          "tablet-2",
          "mb-1",
          "grid-cols",
          "gap-small",
          "row-as-column-gap"
        ),
        (sl.innerHTML = content.innerHTML),
        container.appendChild(sl),
        this.initSlide(),
        this.destroy(),
        (this.slider = null));
  }
  actionResize(isMobile) {
    const content = this.loadContent(),
      sl = document.createElement("div"),
      container = this.querySelector(".gallery-grid-js");
    (container.innerHTML = ""),
      content &&
        container &&
        (isMobile
          ? (sl.classList.add("slide-container"),
            container.classList.remove(
              "tablet-2",
              "mb-1",
              "grid-cols",
              "gap-small",
              "row-as-column-gap"
            ),
            (sl.innerHTML = content),
            container.appendChild(sl),
            this.initSlide(),
            this.destroy(),
            (this.slider = null))
          : (container.classList.add(
              "tablet-2",
              "mb-1",
              "grid-cols",
              "gap-small",
              "row-as-column-gap"
            ),
            (sl.innerHTML = content),
            (container.innerHTML = sl.innerHTML)));
  }
  loadContent() {
    const content = document.createElement("div");
    if (!this.dataset.variantSelected)
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      );
    else {
      if (
        (this.querySelector("template")
          .content.querySelectorAll(".slider-image")
          .forEach((image) => {
            const alt = image.dataset.alt;
            this.dataset.variantSelected == alt &&
              content.appendChild(image.cloneNode(!0));
          }),
        content.querySelector(".slider-image"))
      )
        return content.innerHTML;
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(!0)
      );
    }
    if (content.querySelector(".content-items"))
      return content.querySelector(".content-items").innerHTML;
  }
  pauseMediaGrid() {
    this.querySelectorAll(".slider-model, .slider-image").forEach((e) => {
      e.addEventListener("click", () => {
        window.pauseAllMedia(this);
      });
    });
  }
  playMediaGrid() {
    this.querySelectorAll(".overlay-btn").forEach((e) => {
      e.addEventListener("click", () => {
        window.pauseAllMedia(this);
        const content = document.createElement("div"),
          itemContainer =
            e.closest(".slider-external-video") || e.closest(".slider-video");
        itemContainer &&
          (content.appendChild(
            itemContainer
              .querySelector("template.video-template")
              .content.firstElementChild.cloneNode(!0)
          ),
          itemContainer.querySelector(".video-box").classList.remove("d-none"),
          itemContainer
            .querySelector(".video-box")
            .appendChild(content.querySelector("video, iframe")),
          e.remove());
      });
    });
  }
}
customElements.define("gallery-grid", GalleryGrid);
class CollapsibleRow extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.querySelector(".detail-parent").addEventListener(
      "click",
      _this.onToggle.bind(_this),
      !1
    ),
      this.addEventListener(
        "keypress",
        function (event) {
          event.key === "Enter" && _this.onToggle.bind(_this)(event);
        }.bind(_this),
        !1
      );
  }
  onToggle(e) {
    e.preventDefault();
    const target = this.querySelector(".detail-target"),
      parent = this.querySelector(".detail-parent");
    target &&
      slideAnime({
        target,
        animeType: "slideToggle",
        parent,
      });
  }
}
customElements.define("collapsible-row", CollapsibleRow);
class StockAlert extends Popup {
  constructor() {
    super(), this.initMessage();
  }
  initMessage() {
    const _this = this;
    let stockalertSuccess = "",
      stockalertError = "";
    fetch(window.location.origin + "?section_id=form-infor")
      .then((response) => response.text())
      .then((text) => {
        const html = parser.parseFromString(text, "text/html");
        if (!html) return;
        if (
          (html.querySelector(".stockalert-form-success") &&
            (stockalertSuccess = html.querySelector(
              ".stockalert-form-success"
            ).innerHTML),
          html.querySelector(".stockalert-form-error") &&
            (stockalertError = html.querySelector(
              ".stockalert-form-error"
            ).innerHTML),
          window.location.href.indexOf("contact_posted=true") >= 1)
        ) {
          _this.initToastJs(stockalertSuccess);
          const newURL = location.href.split("?")[0];
          window.history.pushState("object", document.title, newURL);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
  initToastJs(content = "") {
    let myToast = EasyDialogBox.create(
      null,
      "dlg-toast dlg-fade",
      null,
      content,
      null,
      null,
      10,
      400
    );
    (myToast.onHide = myToast.destroy), myToast.show().hide(3e3);
  }
}
customElements.define("stock-alert", StockAlert),
  document.addEventListener("DOMContentLoaded", function () {
    function addProductEntry(productJson2, storedProducts2) {
      storedProducts2 === null && (storedProducts2 = []);
      var currentProductID = productJson2.id,
        product = {
          id: currentProductID,
        };
      if (
        (JSON.parse(localStorage.getItem("product")) != currentProductID &&
          localStorage.setItem("product", JSON.stringify(product)),
        storedProducts2.length < 25)
      )
        for (var i = storedProducts2.length; i--; ) {
          var curProduct = storedProducts2[i];
          if (curProduct.id === product.id) {
            storedProducts2.splice(i, 1);
            break;
          }
        }
      else {
        storedProducts2.shift();
        for (var i = storedProducts2.length; i--; ) {
          var curProduct = storedProducts2[i];
          if (curProduct.id === product.id) {
            storedProducts2.splice(i, 1);
            break;
          }
        }
      }
      storedProducts2.push(product),
        localStorage.getItem(storedProducts2)
          ? localStorage.getItem(
              "bl_recently-viewed-products",
              JSON.stringify(storedProducts2)
            )
          : localStorage.setItem(
              "bl_recently-viewed-products",
              JSON.stringify(storedProducts2)
            );
    }
    const prodData = document.querySelector("[data-product-json]");
    if (prodData != null) {
      var productJson = JSON.parse(prodData.innerHTML),
        storedProducts = JSON.parse(
          localStorage.getItem("bl_recently-viewed-products")
        );
      addProductEntry(productJson, storedProducts);
    }
    var canvasEscFunc = (function () {
      return {
        onEscKeyUp: function () {
          const canvas = document.querySelectorAll(".canvas-main-product");
          canvas.length != 0 &&
            canvas.forEach((e) => {
              e.addEventListener("keyup", (event) => {
                if (event.code?.toUpperCase() === "ESCAPE") {
                  if (e.querySelector(".bls__canvas")) {
                    e.querySelector(".bls__canvas").classList.remove("active");
                    const itemToFocus =
                      e.querySelector(".bls__canvas").dataset.focusItem;
                    document.querySelector("#" + itemToFocus) &&
                      removeTrapFocus(
                        document.querySelector("#" + itemToFocus)
                      );
                  }
                  rootAction.remove();
                }
              });
            });
        },
      };
    })();
    canvasEscFunc.onEscKeyUp();
  });
